class FemotionTheme {
  constructor() {
    this.overlay = document.querySelector('[data-overlay]');
    this.activePanel = null;
    this.searchTimer = null;
    this.init();
  }

  init() {
    this.restoreAnnouncement();
    this.bindGlobalEvents();
    this.initProduct();
    this.initRecommendations();
    this.initStickyHeaderOffset();
  }

  bindGlobalEvents() {
    document.addEventListener('click', (event) => {
      const target = event.target;
      if (target.closest('[data-open-menu]')) return this.openPanel(document.querySelector('[data-menu-drawer]'));
      if (target.closest('[data-close-menu]')) return this.closePanels();
      if (target.closest('[data-open-search]')) return this.openSearch();
      if (target.closest('[data-close-search]')) return this.closePanels();
      if (target.closest('[data-open-cart]')) return this.openPanel(document.querySelector('[data-cart-drawer]'));
      if (target.closest('[data-close-cart]')) return this.closePanels();
      if (target.closest('[data-open-account]')) { event.preventDefault(); return this.openPanel(document.querySelector('[data-account-sheet]')); }
      if (target.closest('[data-close-account]')) return this.closePanels();
      if (target.closest('[data-open-facets]')) return this.openPanel(document.querySelector('[data-facets-drawer]'));
      if (target.closest('[data-close-facets]')) return this.closePanels();
      if (target.closest('[data-overlay]')) return this.closePanels();
      if (target.closest('[data-dismiss-announcement]')) return this.dismissAnnouncement(target.closest('[data-announcement]'));
      if (target.closest('[data-grid-columns]')) return this.setGridColumns(target.closest('[data-grid-columns]'));
      if (target.closest('.js-quick-add')) return this.quickAdd(target.closest('.js-quick-add'));
      if (target.closest('[data-quantity-minus]')) return this.changeQuantity(target.closest('[data-cart-item]'), -1);
      if (target.closest('[data-quantity-plus]')) return this.changeQuantity(target.closest('[data-cart-item]'), 1);
      if (target.closest('[data-cart-remove]')) return this.updateCartLine(target.closest('[data-cart-item]')?.dataset.line, 0);
      if (target.closest('[data-apply-discount]')) return this.applyDiscount();
      if (target.closest('[data-open-size-guide]')) return this.openSizeGuide();
      if (target.closest('[data-close-size-guide]')) return this.closeSizeGuide();
      if (target.closest('[data-size-guide-modal]') && !target.closest('.modal__dialog')) return this.closeSizeGuide();
      if (target.closest('[data-sticky-submit]')) return document.querySelector('[data-product-form] [data-add-to-cart]')?.click();
      if (target.closest('[data-slider-prev]')) return this.scrollSlider(target.closest('[data-slider-prev]'), -1);
      if (target.closest('[data-slider-next]')) return this.scrollSlider(target.closest('[data-slider-next]'), 1);
      if (target.closest('[data-gallery-dot]')) return this.goToGallerySlide(target.closest('[data-gallery-dot]'));
    });

    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-cart-quantity]')) this.updateCartLine(event.target.closest('[data-cart-item]')?.dataset.line, Number(event.target.value));
      if (event.target.matches('[data-option-value]')) this.updateProductVariant(true, event.target);
    });

    document.addEventListener('submit', (event) => {
      if (event.target.matches('[data-product-form]')) {
        if (event.submitter && !event.submitter.matches('[data-add-to-cart]')) return;
        event.preventDefault(); this.addProductForm(event.target);
      }
      if (event.target.matches('.js-set-form')) { event.preventDefault(); this.addSetForm(event.target); }
    });

    const searchInput = document.querySelector('[data-predictive-search-input]');
    searchInput?.addEventListener('input', () => this.predictiveSearch(searchInput.value));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { this.closePanels(); this.closeSizeGuide(); }
    });

    document.addEventListener('shopify:section:load', () => {
      this.overlay = document.querySelector('[data-overlay]');
      this.initProduct();
      this.initRecommendations();
    });
    document.addEventListener('shopify:section:select', (event) => {
      const drawer = event.target.matches?.('[data-cart-drawer]') ? event.target : event.target.querySelector?.('[data-cart-drawer]');
      if (drawer) this.openPanel(drawer);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      if (event.target.matches?.('[data-cart-drawer]') || event.target.querySelector?.('[data-cart-drawer]')) this.closePanels();
    });
  }

  initStickyHeaderOffset() {
    const header = document.querySelector('[data-header].is-sticky');
    if (!header) return;
    const sync = () => document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
    sync(); window.addEventListener('resize', sync, { passive: true });
  }

  openPanel(panel) {
    if (!panel) return;
    this.closePanels(false);
    this.activePanel = panel;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    this.overlay.hidden = false;
    requestAnimationFrame(() => this.overlay.classList.add('is-visible'));
    document.body.classList.add('scroll-locked');
    panel.querySelector('button, a, input, select')?.focus({ preventScroll: true });
    document.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'true'));
  }

  closePanels(hideOverlay = true) {
    document.querySelectorAll('.drawer.is-open,.search-modal.is-open,.account-sheet.is-open').forEach((panel) => {
      panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true');
      document.querySelectorAll(`[aria-controls="${panel.id}"]`).forEach((button) => button.setAttribute('aria-expanded', 'false'));
    });
    if (hideOverlay && this.overlay) {
      this.overlay.classList.remove('is-visible');
      window.setTimeout(() => { if (!this.overlay.classList.contains('is-visible')) this.overlay.hidden = true; }, 260);
      document.body.classList.remove('scroll-locked');
      this.activePanel = null;
    }
  }

  openSearch() {
    const modal = document.querySelector('[data-search-modal]');
    if (!modal) return;
    this.closePanels(false); this.activePanel = modal;
    modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-locked');
    document.querySelector('[data-open-search]')?.setAttribute('aria-expanded', 'true');
    window.setTimeout(() => modal.querySelector('input')?.focus(), 220);
  }

  restoreAnnouncement() {
    const bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    if (sessionStorage.getItem(`femotion-announcement-${bar.dataset.sectionId}`) === 'hidden') bar.hidden = true;
  }

  dismissAnnouncement(bar) {
    if (!bar) return;
    bar.hidden = true;
    sessionStorage.setItem(`femotion-announcement-${bar.dataset.sectionId}`, 'hidden');
  }

  setGridColumns(button) {
    const wrapper = button.closest('[data-mobile-columns]');
    if (!wrapper) return;
    wrapper.dataset.mobileColumns = button.dataset.gridColumns;
    wrapper.querySelectorAll('[data-grid-columns]').forEach((item) => item.classList.toggle('is-active', item === button));
  }

  async predictiveSearch(term) {
    const output = document.querySelector('[data-predictive-search-results]');
    if (!output) return;
    window.clearTimeout(this.searchTimer);
    if (term.trim().length < 2) { output.innerHTML = ''; return; }
    this.searchTimer = window.setTimeout(async () => {
      output.innerHTML = '<div class="predictive-search__empty">Szukam…</div>';
      try {
        const url = `${window.Femotion.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;
        const response = await fetch(url);
        if (!response.ok) throw new Error('search');
        output.innerHTML = await response.text();
      } catch (_) { output.innerHTML = '<div class="predictive-search__empty">Nie udało się pobrać wyników.</div>'; }
    }, 220);
  }

  async quickAdd(button) {
    if (button.disabled || button.classList.contains('is-loading')) return;
    const label = button.textContent;
    button.classList.add('is-loading'); button.disabled = true; button.textContent = '…';
    try { await this.addVariant(Number(button.dataset.variantId), 1); button.textContent = '✓'; }
    catch (_) { button.textContent = '!'; this.announce(window.Femotion.strings.error); }
    window.setTimeout(() => { button.classList.remove('is-loading'); button.disabled = false; button.textContent = label; }, 900);
  }

  async addSetForm(form) {
    const select = form.querySelector('select[name="id"]');
    const button = form.querySelector('button');
    if (!select || !button) return;
    button.disabled = true; const label = button.textContent; button.textContent = 'Dodaję…';
    try { await this.addVariant(Number(select.value), 1); button.textContent = 'Dodano'; }
    catch (_) { button.textContent = 'Błąd'; }
    window.setTimeout(() => { button.disabled = false; button.textContent = label; }, 1000);
  }

  async addProductForm(form) {
    const button = form.querySelector('[data-add-to-cart]');
    if (!button || button.disabled) return;
    const label = button.querySelector('[data-add-to-cart-text]');
    button.disabled = true; button.classList.add('is-loading'); if (label) label.textContent = 'Dodaję…';
    try {
      const data = new FormData(form);
      const response = await fetch(window.Femotion.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      if (!response.ok) throw new Error((await response.json()).description);
      await this.refreshCart(true);
      if (label) label.textContent = 'Dodano';
    } catch (error) { if (label) label.textContent = error.message || window.Femotion.strings.error; this.announce(error.message || window.Femotion.strings.error); }
    window.setTimeout(() => { button.disabled = false; button.classList.remove('is-loading'); if (label) label.textContent = button.dataset.defaultLabel || window.Femotion.strings.addToCart; }, 1200);
  }

  async addVariant(id, quantity) {
    const response = await fetch(window.Femotion.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] })
    });
    if (!response.ok) { const error = await response.json(); throw new Error(error.description || window.Femotion.strings.error); }
    await this.refreshCart(true);
  }

  async changeQuantity(item, delta) {
    if (!item) return;
    const input = item.querySelector('[data-cart-quantity]');
    const quantity = Math.max(0, Number(input?.value || 0) + delta);
    await this.updateCartLine(item.dataset.line, quantity);
  }

  async updateCartLine(line, quantity) {
    if (!line && line !== 0) return;
    try {
      const response = await fetch(window.Femotion.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0) }) });
      if (!response.ok) throw new Error('cart');
      await this.refreshCart(true);
    } catch (_) { this.announce(window.Femotion.strings.error); }
  }

  async refreshCart(openAfter = false) {
    const current = document.querySelector('[data-cart-drawer]');
    const sectionId = current?.dataset.sectionId;
    if (!sectionId) throw new Error('cart');
    const response = await fetch(`${window.Femotion.routes.root}?section_id=${encodeURIComponent(sectionId)}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error('cart');
    const text = await response.text();
    const parser = new DOMParser();
    const fresh = parser.parseFromString(text, 'text/html').querySelector('[data-cart-drawer]');
    if (fresh && current) current.replaceWith(fresh);
    const cartResponse = await fetch(window.Femotion.routes.cart + '.js');
    const cart = await cartResponse.json();
    document.querySelectorAll('[data-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
    this.announce(`Koszyk: ${cart.item_count} produktów`);
    if (openAfter) this.openPanel(document.querySelector('[data-cart-drawer]'));
  }

  applyDiscount() {
    const code = document.querySelector('[data-discount-input]')?.value.trim();
    if (!code) return;
    window.location.href = `${window.Femotion.routes.root}discount/${encodeURIComponent(code)}?redirect=/checkout`;
  }

  initProduct() {
    const section = document.querySelector('[data-main-product]');
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    this.productSection = section;
    try { this.productVariants = JSON.parse(section.querySelector('[data-product-variants]')?.textContent || '[]'); } catch (_) { this.productVariants = []; }
    this.updateProductVariant(false);
    const form = section.querySelector('[data-product-form]');
    const gallery = section.querySelector('[data-product-gallery]');
    if (gallery) {
      const updateGallery = () => {
        const slides = [...gallery.querySelectorAll('.product__media-item')].filter((slide) => !slide.hidden);
        if (!slides.length) return;
        let active = 0, best = Infinity;
        slides.forEach((slide, index) => { const distance = Math.abs(slide.offsetLeft - gallery.scrollLeft); if (distance < best) { best = distance; active = index; } });
        const activeSlide = slides[active];
        section.querySelectorAll('[data-gallery-dot]').forEach((dot) => { const dotSlide = gallery.querySelectorAll('.product__media-item')[Number(dot.dataset.galleryIndex)]; const isActive = dotSlide === activeSlide; dot.classList.toggle('is-active', isActive); if (isActive) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
        const current = section.querySelector('[data-gallery-current]'); if (current) current.textContent = String(active + 1);
        const total = section.querySelector('[data-gallery-total]'); if (total) total.textContent = String(slides.length);
      };
      gallery.addEventListener('scroll', updateGallery, { passive: true }); updateGallery();
    }
    const sticky = section.querySelector('[data-sticky-atc]');
    if (form && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0, rootMargin: '-100px 0px 0px' }).observe(form.querySelector('[data-add-to-cart]'));
    }
    this.initAutoColorFamilies(section);
  }

  async initAutoColorFamilies(section) {
    const family = section?.querySelector('[data-color-family][data-auto-discover="true"]');
    if (!family || family.dataset.initialized === 'true') return;
    family.dataset.initialized = 'true';
    family.setAttribute('aria-busy', 'true');

    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const shortColorName = (value) => {
      const words = String(value || '').trim().split(/\s+/).filter(Boolean);
      if (!words.length) return '';
      const previous = String(words.at(-2) || '').toLowerCase();
      const twoWordPrefixes = new Set(['hot', 'light', 'dark', 'baby', 'dusty', 'deep', 'royal', 'sky', 'off']);
      return twoWordPrefixes.has(previous) ? words.slice(-2).join(' ') : words.at(-1);
    };
    const stripColor = (title, color) => {
      const rawTitle = String(title || '').trim();
      const rawColor = String(color || '').trim();
      if (!rawColor) return rawTitle;
      const escaped = rawColor.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      return rawTitle.replace(new RegExp(`(?:[-–—/|:]\\s*)?${escaped}\\s*$`, 'i'), '').trim();
    };
    const currentTitle = section.dataset.productTitle || '';
    const currentColor = section.dataset.currentColor || '';
    const familyTitle = stripColor(currentTitle, currentColor) || currentTitle;
    const familyKey = normalize(familyTitle);
    const currentPath = new URL(section.dataset.productUrl || location.pathname, location.origin).pathname.replace(/\/$/, '');

    try {
      const params = new URLSearchParams({ q: familyTitle });
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '10');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][fields]', 'title');
      params.set('resources[options][unavailable_products]', 'last');
      const response = await fetch(`${window.Femotion.routes.root}search/suggest.json?${params}`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Nie udało się pobrać rodziny kolorów');
      const payload = await response.json();
      const products = payload?.resources?.results?.products || [];
      const candidates = products.filter((item) => {
        if (!item?.url) return false;
        const path = new URL(item.url, location.origin).pathname.replace(/\/$/, '');
        if (path === currentPath) return false;
        const titleKey = normalize(item.title);
        return titleKey === normalize(currentTitle) || titleKey.startsWith(familyKey) || familyKey.startsWith(titleKey);
      }).slice(0, 9);

      const siblings = (await Promise.all(candidates.map(async (item) => {
        try {
          const pageResponse = await fetch(item.url, { headers: { Accept: 'text/html' } });
          if (!pageResponse.ok) return null;
          const page = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');
          const productSection = page.querySelector('[data-main-product]');
          const siblingTitle = productSection?.dataset.productTitle || item.title || '';
          const siblingColor = productSection?.dataset.currentColor || siblingTitle.split(/\s+/).pop() || '';
          if (normalize(stripColor(siblingTitle, siblingColor)) !== familyKey) return null;
          const rawImage = item.image || item.featured_image;
          const imageUrl = typeof rawImage === 'string' ? rawImage : (rawImage?.url || rawImage?.src || productSection?.querySelector('[data-product-gallery] img')?.src);
          return { url: item.url, title: siblingTitle, color: siblingColor, imageUrl };
        } catch (_) { return null; }
      }))).filter(Boolean).filter((item, index, items) => items.findIndex((other) => new URL(other.url, location.origin).pathname === new URL(item.url, location.origin).pathname) === index).slice(0, 5);

      siblings.forEach((item) => {
        const tile = document.createElement('div');
        tile.className = 'color-family__item';
        const link = document.createElement('a');
        link.className = 'color-family__image';
        link.href = item.url;
        link.setAttribute('aria-label', `${item.title} — ${item.color}`);
        if (item.imageUrl) {
          const image = document.createElement('img');
          image.src = item.imageUrl;
          image.alt = item.title;
          image.loading = 'lazy';
          image.width = 360;
          image.height = 480;
          link.appendChild(image);
        }
        const name = document.createElement('span');
        name.className = 'color-family__name';
        name.textContent = shortColorName(item.color);
        tile.append(link, name);
        family.appendChild(tile);
      });
    } catch (_) {
      /* Ręczne bloki i metafield pozostają niezawodnym trybem zapasowym. */
    } finally {
      family.setAttribute('aria-busy', 'false');
    }
  }

  updateProductVariant(updateUrl = true, changedInput = null) {
    const section = this.productSection || document.querySelector('[data-main-product]');
    if (!section || !this.productVariants?.length) return;
    const chosen = [...section.querySelectorAll('[data-option-value]:checked')].sort((a,b) => Number(a.dataset.optionPosition)-Number(b.dataset.optionPosition)).map((input) => input.value);
    let variant = this.productVariants.find((item) => item.options.every((option, index) => option === chosen[index]));
    if ((!variant || !variant.available) && changedInput) {
      const changedPosition = Number(changedInput.dataset.optionPosition) - 1;
      const fallbackVariant = this.productVariants.find((item) => item.available && item.options[changedPosition] === changedInput.value);
      if (fallbackVariant) {
        variant = fallbackVariant;
        fallbackVariant.options.forEach((value, index) => {
          section.querySelectorAll(`[data-option-value][data-option-position="${index + 1}"]`).forEach((input) => { input.checked = input.value === value; });
        });
      }
    }
    const idInput = section.querySelector('[data-variant-id]');
    const button = section.querySelector('[data-add-to-cart]');
    const label = section.querySelector('[data-add-to-cart-text]');
    if (!variant) { if (button) button.disabled = true; if (label) label.textContent = window.Femotion.strings.unavailable || 'Niedostępne'; return; }
    if (idInput) idInput.value = variant.id;
    if (button) button.disabled = !variant.available;
    if (label) label.textContent = variant.available ? (button?.dataset.defaultLabel || window.Femotion.strings.addToCart) : (button?.dataset.soldOutLabel || window.Femotion.strings.soldOut);
    section.querySelectorAll('[data-price]').forEach((node) => node.textContent = this.formatMoney(variant.price));
    section.querySelectorAll('[data-sticky-price]').forEach((node) => node.textContent = this.formatMoney(variant.price));
    const stickyButton = section.querySelector('[data-sticky-submit]'); if (stickyButton) stickyButton.disabled = !variant.available;
    section.querySelectorAll('[data-option-value]').forEach((input) => {
      const pos = Number(input.dataset.optionPosition) - 1;
      const possible = this.productVariants.some((item) => item.available && item.options[pos] === input.value);
      input.disabled = !possible; input.nextElementSibling?.classList.toggle('is-unavailable', !possible);
    });
    if (variant.featured_media?.id) {
      const gallery = section.querySelector('[data-product-gallery]');
      const mediaSlide = section.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (gallery && mediaSlide) gallery.scrollTo({ left: mediaSlide.offsetLeft, behavior: updateUrl ? 'smooth' : 'auto' });
    }
    this.filterGalleryByColor(section, changedInput?.matches('[data-color-option]') ? changedInput : section.querySelector('[data-color-option]:checked'), variant, updateUrl);
    if (updateUrl && history.replaceState) history.replaceState({}, '', `${section.dataset.productUrl}?variant=${variant.id}`);
  }

  filterGalleryByColor(section, colorInput, activeVariant, animate = true) {
    const gallery = section.querySelector('[data-product-gallery]');
    if (!gallery || !colorInput) return;
    const colorPosition = Number(colorInput.dataset.optionPosition) - 1;
    const selectedColor = colorInput.value;
    const slides = [...gallery.querySelectorAll('.product__media-item')];
    const colorValues = [...new Set(this.productVariants.map((item) => item.options[colorPosition]).filter(Boolean))];
    if (section.dataset.linkedColorProducts === 'true' || colorValues.length <= 1) {
      slides.forEach((slide, index) => {
        slide.hidden = false;
        const dot = section.querySelector(`[data-gallery-dot][data-gallery-index="${index}"]`);
        if (dot) dot.hidden = false;
      });
      const total = section.querySelector('[data-gallery-total]'); if (total) total.textContent = String(slides.length);
      const current = section.querySelector('[data-gallery-current]'); if (current) current.textContent = slides.length ? '1' : '0';
      return;
    }
    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const normalizedColor = normalize(selectedColor);
    const variantMediaIds = new Set(
      this.productVariants
        .filter((item) => item.options[colorPosition] === selectedColor && item.featured_media?.id)
        .map((item) => String(item.featured_media.id))
    );
    const allowedIds = new Set(variantMediaIds);
    const altMatchedIds = new Set();
    slides.forEach((slide) => {
      const alt = normalize(slide.dataset.mediaAlt);
      if (normalizedColor && alt.includes(normalizedColor)) {
        allowedIds.add(String(slide.dataset.mediaId));
        altMatchedIds.add(String(slide.dataset.mediaId));
      }
    });
    if (activeVariant?.featured_media?.id) allowedIds.add(String(activeVariant.featured_media.id));
    const groupingMode = section.dataset.colorMediaGrouping || 'auto';
    if (altMatchedIds.size <= 1 && groupingMode !== 'assigned_only') {
      const colorMarkers = colorValues.map((color) => {
        const mediaId = this.productVariants.find((item) => item.options[colorPosition] === color && item.featured_media?.id)?.featured_media?.id;
        const slideIndex = slides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        return { color, mediaId, slideIndex };
      }).filter((marker) => marker.slideIndex >= 0).sort((a, b) => a.slideIndex - b.slideIndex);
      const selectedMarkerIndex = colorMarkers.findIndex((marker) => marker.color === selectedColor);
      if (colorMarkers.length > 1 && selectedMarkerIndex >= 0) {
        const firstIndex = colorMarkers[0].slideIndex;
        const lastIndex = colorMarkers[colorMarkers.length - 1].slideIndex;
        const markersAreClustered = lastIndex - firstIndex <= colorMarkers.length + 1;
        const useAngleSeries = groupingMode === 'by_angle' || (groupingMode === 'auto' && markersAreClustered);
        if (useAngleSeries) {
          slides.forEach((slide, index) => {
            if (index >= firstIndex && (index - firstIndex) % colorMarkers.length === selectedMarkerIndex) allowedIds.add(String(slide.dataset.mediaId));
          });
        } else {
          const start = colorMarkers[selectedMarkerIndex].slideIndex;
          const end = colorMarkers[selectedMarkerIndex + 1]?.slideIndex ?? slides.length;
          slides.slice(start, end).forEach((slide) => allowedIds.add(String(slide.dataset.mediaId)));
        }
      }
    }
    const shouldFilter = allowedIds.size > 0;
    slides.forEach((slide, index) => {
      slide.hidden = shouldFilter && !allowedIds.has(String(slide.dataset.mediaId));
      const dot = section.querySelector(`[data-gallery-dot][data-gallery-index="${index}"]`);
      if (dot) dot.hidden = slide.hidden;
    });
    const visibleSlides = slides.filter((slide) => !slide.hidden);
    const target = visibleSlides.find((slide) => String(slide.dataset.mediaId) === String(activeVariant?.featured_media?.id)) || visibleSlides[0];
    const total = section.querySelector('[data-gallery-total]'); if (total) total.textContent = String(visibleSlides.length);
    const current = section.querySelector('[data-gallery-current]'); if (current) current.textContent = visibleSlides.length ? '1' : '0';
    if (target) requestAnimationFrame(() => gallery.scrollTo({ left: target.offsetLeft, behavior: animate ? 'smooth' : 'auto' }));
  }

  formatMoney(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', { style: 'currency', currency: window.Femotion.currency || 'PLN' }).format(cents / 100); }
    catch (_) { return `${(cents / 100).toFixed(2).replace('.', ',')} zł`; }
  }

  openSizeGuide() { const modal = document.querySelector('[data-size-guide-modal]'); if (!modal) return; modal.classList.add('is-open'); modal.setAttribute('aria-hidden','false'); document.body.classList.add('scroll-locked'); modal.querySelector('button')?.focus(); }
  closeSizeGuide() { const modal = document.querySelector('[data-size-guide-modal]'); if (!modal) return; modal.classList.remove('is-open'); modal.setAttribute('aria-hidden','true'); document.body.classList.remove('scroll-locked'); }

  scrollSlider(button, direction) {
    const track = button.closest('section')?.querySelector('[data-slider-track]');
    if (!track) return;
    track.scrollBy({ left: track.clientWidth * 0.82 * direction, behavior: 'smooth' });
  }

  goToGallerySlide(dot) {
    const section = dot.closest('[data-main-product]');
    const gallery = section?.querySelector('[data-product-gallery]');
    const slide = gallery?.querySelectorAll('.product__media-item')[Number(dot.dataset.galleryIndex)];
    if (gallery && slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  initRecommendations() {
    document.querySelectorAll('[data-product-recommendations][data-url]').forEach(async (section) => {
      if (section.dataset.loaded === 'true' || section.innerHTML.trim()) return;
      section.dataset.loaded = 'true';
      try {
        const response = await fetch(section.dataset.url);
        const html = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('[data-product-recommendations]');
        if (html?.innerHTML.trim()) section.innerHTML = html.innerHTML;
      } catch (_) {}
    });
  }

  announce(message) { const region = document.querySelector('[data-live-region]'); if (!region) return; region.textContent = ''; window.setTimeout(() => region.textContent = message, 30); }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => new FemotionTheme());
else new FemotionTheme();
